import { render, staticRenderFns } from "./NationalGeographic.vue?vue&type=template&id=712602d2&scoped=true"
import script from "./NationalGeographic.vue?vue&type=script&lang=js"
export * from "./NationalGeographic.vue?vue&type=script&lang=js"
import style0 from "./NationalGeographic.vue?vue&type=style&index=0&id=712602d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712602d2",
  null
  
)

export default component.exports